import type { SalonRow, SalonStage } from '@manaro/contracts'
import { moderationState, type CatalogFilter } from './moderation.ts'

export type StageFilter = 'all' | SalonStage

export interface Facets {
  rows: SalonRow[]
  /** Rows the catalog filter leaves — what the stage chips count. */
  stageTotal: number
  stageCounts: Record<string, number>
  /** Rows the stage filter leaves — what the catalog chips count. */
  catalogTotal: number
  catalogCounts: Record<string, number>
}

export function countBy(rows: SalonRow[], key: (row: SalonRow) => string): Record<string, number> {
  return rows.reduce<Record<string, number>>((counts, row) => {
    const value = key(row)
    return { ...counts, [value]: (counts[value] ?? 0) + 1 }
  }, {})
}

const catalogOf = (row: SalonRow): string => moderationState(row) ?? 'none'

/** Stage and catalog are facets: each one counts the rows the other filter leaves, the list applies both. */
export function facetSalons(rows: SalonRow[], stage: StageFilter, catalog: CatalogFilter): Facets {
  const byStage = stage === 'all' ? rows : rows.filter((row) => row.stage === stage)
  const byCatalog = catalog === 'all' ? rows : rows.filter((row) => moderationState(row) === catalog)

  return {
    rows: catalog === 'all' ? byStage : byStage.filter((row) => moderationState(row) === catalog),
    stageTotal: byCatalog.length,
    stageCounts: countBy(byCatalog, (row) => row.stage),
    catalogTotal: byStage.length,
    catalogCounts: countBy(byStage, catalogOf),
  }
}
